// extracted by mini-css-extract-plugin
module.exports = {"douPrice":"_11627","dou":"_7232","unit":"_294","extra":"_15530","prefix":"_6635"};